import { useStartNodeContext } from '../../StartNodeEditor.context';
import { InternalOnChangeProp } from '../../StartNodeEditor.types';
import { useGetEntrySourceMetadata } from '../useGetEntrySourceMetadata';

const getCorrectedValue = (resourceValueType: string, updatedValue: string | number) => {
  if (resourceValueType === 'number') {
    return Number(updatedValue);
  } else if (resourceValueType === 'string') {
    return `${updatedValue}`;
  }
};

/**
 * used for secondary resource component changes (i.e. resourceComponents)
 * @returns {function} A function that sets node data with a properly formatted value
 */
export const useHandleResourceValueChange = () => {
  const { setNodeData } = useStartNodeContext();
  const { resourceValueType = '', resourceFieldName } = useGetEntrySourceMetadata();

  return ({ value: updatedValue, label }: InternalOnChangeProp) => {
    const correctedValue = getCorrectedValue(resourceValueType, updatedValue);
    // only set node data if there is a resource
    // not when triggered by an initial render
    // also check for empty string as label (when user backspaces on custom event)
    if ((label || typeof label === 'string') && resourceFieldName) {
      setNodeData({
        [resourceFieldName]: correctedValue,
        resource: { name: label },
      });
    }
  };
};
